<template>
    <v-app>
        <div class="mobile" id="mobile">
            <div class="client-col">
                <div id="header" class="app-width">
                    <div class="header-logo font-size-40">
                        <div class="header-left">
                            <img class="header-logo-img hover-opacity animation-ease" src="@/assets/logo-hkaa.png">
                            <img class="header-logo-img hover-opacity animation-ease" src="@/assets/logo-race.png">
                        </div>
                    </div>
                </div>

                <div class="content-body">
                    <router-view/>
                </div>
                <div id="footer">
                    <!--                <img id="footerImg" src="@/assets/footer.png"><br>-->
                    <img id="footerLogo" src="@/assets/logo-hkaa.png" class="mb-1"><br>
                    <label id="footerLabel" class="font-size-40">© {{$t('home.all_rights_reserved')}}</label>
                </div>
            </div>
        </div>
    </v-app>
</template>

<script>
    import {library} from '@fortawesome/fontawesome-svg-core'
    import {faBars, faBell, faSignOutAlt, faTools} from '@fortawesome/free-solid-svg-icons'


    library.add(faBars, faBell, faTools, faSignOutAlt);
    export default {
        name: 'Mobile',
    }
</script>

<style lang="less">
    .mobile {
        height: 100%;

        .client-col {
            min-height: 100%;
            height: auto;
            position: relative;
            padding-bottom: 160px;
        }

        #header {
            width: 100%;
            padding-top: 2rem;
            background-color: white;
            display: flex;
            flex-direction: column;
            overflow-y: auto;

            &.admin-header {
                background-color: #62cbd0;
            }

            .header-logo {
                display: flex;
                justify-content: space-between;
                align-items: center;


                .header-left {

                }

                .header-right {
                    display: flex;
                    justify-content: flex-end;
                    align-items: center;

                    a {
                        display: block;
                        text-decoration: none;
                        margin-right: 20px;
                        color: black;
                    }
                }
            }
        }

        #footer {
            width: 100%;
            border-top: 1px solid #f0f0f0;
            background-color: #f2f5f7;

            padding: 20px 0;

            position: absolute;
            bottom: 0;
            left: 0;

            #footerLogo {
                height: 64px;
            }

            #footerImg {
                height: 15px;
            }
        }
    }

</style>
